import coreDefaults from './coreDefaults';
import getThemeDefaults from './getThemeDefaults';
import ThemeInterface from './ThemeInterface';
import deepObjMerge from '../v2/utils/deepObjMerge';
import whitelabel from './sites/whitelabel';
import getArtemisThemeDefaults from './getArtemisThemeDefaults';

export default (theme: any = whitelabel, artemisTheme: any = {}, isUsingArtemisStyles: boolean = false): ThemeInterface => {
  const core = {
    ...coreDefaults,
    ...theme.core,
  };
    
  if (isUsingArtemisStyles && artemisTheme.colors?.palette) {
    core.brand = artemisTheme.colors.palette.brand.base;
    core.accent = artemisTheme.colors.palette.accent.base;
  }
  
  const themeDefaults = isUsingArtemisStyles ? getArtemisThemeDefaults(core) : getThemeDefaults(core);
  const mergedTheme = deepObjMerge(themeDefaults, theme);
  
  return {
    ...deepObjMerge(mergedTheme, artemisTheme),
    core,
  };
};
